<template>
  <section class="min-w1600">
    <div class="searchwrap">
      <div class="searchBar">
         <div class="box-ui-select searchbar-content">
           <div class="title"><span>{{ $t('searchArea.date') }}</span></div>
           <div class="fx">
             <select v-model="reqData.dateType" class="mr-5">
               <option value="reg">{{ $t('table.head.applyDate') }}</option>
               <option value="upd">{{ $t('table.head.updDate') }}</option>
             </select>
             <date-selector :class="'searchbar-content'" @setStartDate="setStartDate" @setEndDate="setEndDate" :startDefault="startDefault" :endDefault="endDefault" :configs="dateConfigs" />
           </div>
         </div>
      </div>
      <div class="searchBar">
         <div class="box-ui-select searchbar-content">
           <div class="title"><span>{{ $t('searchArea.searchCon') }}</span></div>
           <div>
             <select class="mr-5" v-model="reqData.insuredType">
              <option value="">{{ $t('table.head.type') }}</option>
              <option value="1">{{ $t('searchArea.applypay') }}</option>
              <option value="-1">{{ $t('searchArea.refund') }}</option>
              <option value="2">{{ $t('searchArea.useSub') }}</option>
              <option value="5">{{ $t('searchArea.payUpper') }}</option>
              <option value="-5">{{ $t('searchArea.reUpper') }}</option>
              <option value="7">{{ $t('searchArea.company') }}</option>
            </select>
            <select class="mr-5" v-model="reqData.insuredStatus"><!-- v-if="reqData.insuredType" -->
              <option value="">{{ $t('common.all') }}</option>
              <option value="0">{{ $t('common.request') }}</option>
              <option value="2">{{ $t('common.wait') }}</option>
              <option value="1">{{ $t('button.approval') }}</option>
              <option value="-1">{{ $t('searchArea.refu') }}</option>
            </select>
            <button class="btn-search" type="button" @click="pageSeach">
              <i class="fas fa-search"></i>
            </button>
           </div>
         </div>
      </div>
      <memo></memo>
    </div>
    <div class="main-contents-wrapper">
      <div class="table-wrapper">
        <table class="mainTable">
          <table-head :headInfo="headInfo" />
          <tbody v-if="list.length !== 0">
            <tr v-for="(item, idx) in list" :key="idx">
              <td>{{idx+1}}</td>
              <td>
                <span class="money-apply">{{ numberWithCommas(item.insuredAmt) }}</span>
              </td>
              <td>
                <span class="money-apply">{{ numberWithCommas(item.preInsuredAmt) }}</span>
              </td>
              <td>
                <span class="money-apply">{{ item.realInsuredAmt ? numberWithCommas(item.realInsuredAmt) : "-" }}</span>
              </td>
              <td v-if="item.insuredStatus === '1'">{{ numberWithCommas(Number(item.preInsuredAmt) + Number(item.realInsuredAmt)) }}</td>
              <td v-else>-</td>
              <td>{{ item.insuredDesc }}</td>
              <td style="width: 15%">
                <span>{{ replaceDateT(item.requestDate) }}</span>
              </td>
              <td style="width: 15%">
                <span>{{ item.insuredStatus !== "0" && item.insuredStatus !== "2" ? replaceDateT(item.successDate) : "-" }}</span>
              </td>
              <td class="statusColor" :class="item.statusClass">{{ item.statusText }}</td>
            </tr>
          </tbody>
          <tbody v-else>
            <tr>
              <td colspan="9">
                <span class="notice-tableDataEmpty">{{ $t('txt.noData') }}</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <pagination v-if="list.length !== 0" @goPage="setTableData" :pageNum="pageInfo.page" :pageSize="pageInfo.count_per_list" :totalCount="pageInfo.tatal_list_count" />
  </section>
</template>

<script>
import SearchFilter from '@/components/common/SearchFilter'
import DateSelector from '@/components/common/DateSelector'
import TableHead from '@/components/main/table/Head.vue'
import { insuredApplyList } from '@/api/insured.js'
import Pagination from '@/components/common/Pagination'
import Memo from '@/components/common/memo'

export default {
  name: 'InsuredApplyList',
  components: {
    TableHead,
    DateSelector,
    SearchFilter,
    Pagination,
    Memo
  },
  watch: {
    'reqData.insuredType': {
      handler () {
        this.reqData.insuredStatus = ''
      }
    }
  },
  data: function () {
    return {
      tableName: 'Basic',
      headInfo: {
        fstColumn: false,
        dataList: ['index', 'insuredAmt', 'preInsuredAmt', 'realInsuredAmt', 'postInsuredAmt', 'type', 'applyDate', 'updDate', 'status']
      },
      reqData: {
        insuredType: '',
        insuredStatus: '',
        dateType: 'reg',
        startDate: '',
        endDate: '',
        count_per_list: '30',
        page: 1
      },
      searchInputOption: '',
      dateConfigs: {
        enableTime: true,
        dateFormat: 'Y-m-d H:i'
      },
      startDefault: '',
      endDefault: '',
      list: [],
      pageInfo: {}
    }
  },
  methods: {
    pageSeach () {
      this.setTableData(1)
    },
    setStartDate (date) {
      let _date = ''
      if (!date) {
        _date = new Date()
        _date.setHours(0, 0, 0)
      } else {
        _date = date[0]
        _date.setSeconds(0)
      }
      this.startDefault = _date
      this.reqData.startDate = this.getDateStr(_date, 'yyyy-MM-dd HH:mm:ss')
    },
    setEndDate (date) {
      // console.log(date[0]);
      let _date = ''
      if (!date) {
        _date = new Date()
        _date.setHours(23, 59, 59)
      } else {
        _date = date[0]
        _date.setSeconds(59)
      }
      this.endDefault = _date
      this.reqData.endDate = this.getDateStr(_date, 'yyyy-MM-dd HH:mm:ss')
    },
    async setTableData (pageNum) {
      const req = this.reqData
      if (pageNum) {
        req.page = pageNum
      }
      const res = await insuredApplyList(req)
      const list = res.data.list
      const pageInfo = res.data.pageInfo
      if (list) {
        this.list = this.dataConvertor(list)
      }
      if (pageInfo) {
        this.pageInfo = pageInfo
      }
    },
    dataConvertor (dataList) {
      // console.log(dataList);
      const _dataList = dataList
      if (!dataList.length || dataList.length === 0) {
        return _dataList
      }
      _dataList.forEach(items => {
        const status = items.insuredStatus
        let statusText = ''
        // - 0:요청, 1:완료, 2:대기 , -1"거부
        if (status === '0') {
          statusText = '신청'
          items.statusClass = 'apply'
        } else if (status === '1') {
          statusText = '완료'
          items.statusClass = 'approve'
        } else if (status === '2') {
          statusText = '대기'
          items.statusClass = 'wait'
        } else if (status === '-1') {
          statusText = '거절'
          items.statusClass = 'refuse'
        }
        items.statusText = statusText
      })
      return _dataList
    }
  },
  async created () {
    this.setStartDate()
    this.setEndDate()
    this.setTableData()
  }
}
</script>

<style scoped>
.statusColor {
  font-weight: 700;
}
.statusColor.apply {
  color: #ef8c1d;
}
.statusColor.approve {
  color: blue;
}
.statusColor.refuse {
  color: red;
}
.statusColor.wait {
  color: green;
}
</style>
